/**
 * @author wyr
 * @date 2021/12/3 16:44
 */
import CrossStorage from 'cross-storage'
import { Message } from 'element-ui'
let host = window.location.host,httpData = host.split(":"),protocol = window.location.protocol;
let portHttp = httpData?httpData[0]:'';
let portValue;
if(host.indexOf('192.168.1.245') >= 0){
  portValue = protocol+"//"+(portHttp ? portHttp+':9990':'');

}else if(host.indexOf('gas.deyt.cn') >= 0){
  /*正式环境*/
  portValue =  protocol+'//iot.deyt.cn';
}else{
  /*开发*/
 portValue = protocol+"//"+(portHttp ? portHttp+':8080':'');
}
var storage
/**添加Storage**/
export const addStorage = function(name, value) {
  storage.onConnect().then(function() {
    return storage.set(name, value);
  }).catch(function(err) {
    console.log(err)
    Message.error('远程服务失败');
  }).then(function() {
    storage.close();
  });
};

/**获取Storage**/
export const getStorage = function(name,callback) {
  storage = new CrossStorage.CrossStorageClient(portValue+'/#/Hub',{
    timeout: 10000,
  });
  return new Promise(function (resolve, reject) {
    storage.onConnect().then(function () {
      return storage.get('infor');
    }).then(function (res) {
      resolve(JSON.parse(res));
    })['catch'](function (err) {
      reject(err);
    });
  });

  /*storage.onConnect()
    .then(function() {
      return storage.get(name);
    }).then(function(res) {
    callback(res);
  })['catch'](function(err) {
    console.log(err,999)
    Message.error('远程服务失败');
  });*/
};

/**删除Storage**/
export const delStorage = function(name) {
  storage.onConnect().then(function() {
    return storage.del(name);
  }).then(function() {
    storage.close();
  });
};

/**获取Storagekeys**/
export const getStorageKeys = function(callback) {
  storage.onConnect().then(function() {
    return storage.getKeys();
  }).then(function(keys) {
    callback(keys)
  });
};

/**清除Storage**/
export const clearStorage = function() {
  return new Promise(function (resolve, reject) {
    storage.onConnect().then(function() {
      return storage.clear();
    });
  })

};



// WEBPACK FOOTER //
// ./src/assets/js/storage.js